module.exports = __webpack_public_path__ + "ec6f2b2f9e043e8a60683926277d6b83.svg";